import { FC, useRef, useState } from 'react';
import { ContextMenuProps } from '@business/interfaces/context-menu';
import { SVGAssets } from '@business/assets/vectors';
import { useOutsideClickHandler } from '@utils/hooks/useOutsideClickHandler';
import { Button } from '../Button';

export const ContextMenu: FC<ContextMenuProps> = ({
  menuItems,
  isAlternateView = false,
  wrapperClass = '',
  itemContainerClass,
  iconClass = 'w-4 h-4',
  icon
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState<boolean>(false);
  const menuRef = useRef<HTMLDivElement | null>(null);

  useOutsideClickHandler(menuRef, () => {
    setIsDropdownOpen(false);
  });

  return (
    <div ref={menuRef}>
      {isAlternateView ? (
        <div />
      ) : (
        <div
          data-testid="context-menu"
          className={`relative ${wrapperClass ?? ''}`}>
          <div className="dropdown context-menu-wrapper">
            {/* Trigger */}
            <Button
              btnStyle="link"
              className="inline-flex cursor-pointer three-dots-menu"
              onClick={e => {
                e.stopPropagation();
                setIsDropdownOpen(prev => !prev);
              }}>
              {icon ?? (
                <SVGAssets.ThreeDots
                  className={iconClass}
                  data-testid="three-dots-icon"
                />
              )}
            </Button>

            {/* Dropdown */}
            {isDropdownOpen && (
              <ul
                data-testid="dropdown-content"
                className={`absolute right-0 top-full mt-2 shadow-lg bg-white rounded-md border border-gray-200 min-w-[124px] z-[9999]
                  ${itemContainerClass ?? ''}
                `}>
                {menuItems.map(row => {
                  return (
                    row && (
                      <Button
                        btnStyle="link"
                        data-testid={`menu-item-${row?.id}`}
                        key={row?.id}
                        className="!flex justify-between items-center w-full !text-left
                                   px-4 py-2 text-sm hover:bg-gray-200"
                        onClick={e => {
                          e.stopPropagation();
                          row?.onClick();
                          setIsDropdownOpen(false);
                        }}>
                        {row?.href ? (
                          <Button
                            btnStyle="link"
                            href={row?.href}
                            data-testid="menu-item-button"
                          />
                        ) : (
                          row?.label
                        )}
                      </Button>
                    )
                  );
                })}
              </ul>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
